import { Helmet } from 'react-helmet-async';

const SITE_URL = "https://magnuskor.com";

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogImage = `${SITE_URL}/og-image.png?v=2`,
  ogType = "website",
  noIndex = false,
  jsonLd = null,
  article = null
}) => {
  const siteTitle = "Magnus Kor Talent Partners";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Talent Advisory for VC-Backed SaaS Startups`;
  const defaultDescription = "Magnus Kor Talent Partners is a premium talent advisory firm for VC-backed SaaS startups. We build core teams across Engineering, Product, Growth, and Customer Success from IC to C-suite.";
  const metaDescription = description || defaultDescription;
  const defaultKeywords = "talent advisory, HR consultancy, SaaS startup hiring, VC-backed startup recruitment, engineering hiring, product manager hiring, Magnus Kor, L&D Nexus";
  const metaKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      {canonical && <link rel="canonical" href={canonical} />}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={fullTitle} />

      {/* Article meta (for blog posts) */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:author" content="Magnus Kor Talent Partners" />
          <meta property="article:section" content={article.section} />
        </>
      )}

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
